import React from 'react'
import { Redirect } from 'react-router-dom'
import { getApplyStepPath } from '../MainRoutes/utils'

function AccountVerificationSuccess({ lastApply }) {
  return (
    <Redirect to={getApplyStepPath(lastApply)} />
  )
}

export default AccountVerificationSuccess
